//
// Argument.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./ArgumentBase";
import "../../common/values/ArgumentValue";

var Argument = createModule("BIRD::Argument", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::ArgumentBase"], EventDispatcher, [
    ,
    {
        type: 7,
        value: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default Argument;
